import { Component, Input, OnInit } from '@angular/core';
import { StaticPagesService } from 'src/app/Services/static-pages.service';

@Component({
  selector: 'app-download-app',
  templateUrl: './download-app.component.html',
  styleUrls: ['./download-app.component.scss'],
})
export class DownloadAppComponent implements OnInit {
  @Input() lang: string = '';
  environmentVariables: any;
  iosDev = false;
  showApps = true;
  constructor(private confgServ: StaticPagesService) {
    this.getInitilizingData();
  }

  ngOnInit(): void {}

  getInitilizingData() {
    this.confgServ.getenvConfig().subscribe((res) => {
      this.environmentVariables = res;
      if (this.environmentVariables.ENABLE_DOWNLOAD_APP) {
        this.showApps = true;
      } else {
        this.showApps = false;
      }
    });
    if (this.isIOSDevice()) {
      this.iosDev = true;
    } else {
      this.iosDev = false;
    }
  }
  isIOSDevice() {
    return (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  }
  hideapp() {
    this.showApps = false;
    this.environmentVariables.ENABLE_DOWNLOAD_APP = false;
  }
}
